<template>
    <div class="record-board-container">
        <Title :strong="2">
            榜单
            <a-button v-if="!competition" class="fold-button" type="link"
                @click="toggleFold()"
            >
                <span v-if="folded"><a-icon type="plus-square" />展开榜单</span>
                <span v-else><a-icon type="minus-square" />折叠榜单</span>
            </a-button>
        </Title>
        <div v-if="competition" class="unshow-info">
            <a-alert type="info" show-icon>
                <span slot="description">-- 比赛塔不显示成绩 --</span>
            </a-alert>
        </div>
        <Endings v-show="!folded" v-else-if="flatDifficulty" v-bind="record[0]" />
        <a-collapse v-show="!folded" v-else v-model="activeDifficulty" :bordered="false">
            <a-collapse-panel
                v-for="difficulty of record" :key="difficulty.label"
            >
                <span slot="header" class="header">
                    {{ difficulty.label }}
                </span>
                <Endings v-bind="difficulty" />
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'
import Endings from '../components/Endings.vue'
import { default as AAlert } from 'ant-design-vue/es/alert';
import axios from 'axios';

export default {
    props: {
        record: Array,
        competition: { type: Boolean, default: false }
    },
    data: () => ({
        activeDifficulty: [],
        folded: false,
    }),
    provide() {
        return {
            loadMore: this.loadMore
        }
    },
    inject: [ 'app' ],
    computed: {
        flatDifficulty() {
            if (this.record.length === 1 && this.record[0].label === '') {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        this.activeDifficulty = this.record
            .filter(e => (Number(e.fold) === 0))
            .map(e => e.label);
    },
    methods: {
        toggleFold() {
            this.folded = !this.folded;
        },
        async loadMore(difficulty, ending, count) {
            console.log(difficulty, ending);
            try {
                const { data } = await axios.get("/backend/tower/fetchMoreSubmissions.php", {
                    params: {
                        name: this.app.tower.name, difficulty, ending, count
                    }
                });
                const targetEnding = this.record
                    .find(e => e.label === difficulty)
                    .endings
                    .find(e => e.name === ending);
                console.log(targetEnding);
                targetEnding.submissions = data.submissions
                targetEnding.hasFetchAll = data.hasFetchAll;
            } catch (e) {
                this.$message.error(`拉取失败: ${ e }`);
            }
        }
    },
    components: {
        Title, Endings, AAlert,
    },
}
</script>

<style lang="less" scoped>
.record-board-container {
    text-align: left;
}
.unshow-info {
    margin: 10px;
}
.header {
    font-size: 16px;
}
.fold-button {
    color: rgba(0, 0, 0, 0.45);;
}
</style>
